/* ============================================================
   Keyring designer (2D) — products tagged `customkeyring`.

   Layering: the plate area of keyring-base.png is transparent, so
   the customer photo is drawn UNDER the keyring image and shows
   through the hole. The metal bezel always stays on top.

   Left plate  : photo — drag, zoom, rotate, flip.
   Right plate : text in Courgette, one row per line the customer types
                 (max LINE_MAX characters each, no overall limit).

   The DOM preview and the generated print files share the same
   geometry and the same line-wrapping pass, so what the customer
   positions is exactly what we print.
   ============================================================ */
(function () {
  "use strict";

  var PLACEHOLDER = "Insert Text Here";
  var TEXT_FONT = "Courgette";
  var TEXT_COLOR = "#14141a";
  var LINE_MAX = 15;

  var stage = document.querySelector("[data-kr-stage]");
  if (!stage) return;

  var baseImg = stage.querySelector(".kr__base");
  var frontZone = stage.querySelector("[data-kr-front]");
  var backZone = stage.querySelector("[data-kr-back]");
  var photoEl = stage.querySelector("[data-kr-photo]");
  var hintEl = stage.querySelector("[data-kr-hint]");
  var textEl = stage.querySelector("[data-kr-text]");

  var drop = document.querySelector("[data-kr-drop]");
  var dropLabel = document.querySelector("[data-kr-drop-label]");
  var fileInput = document.querySelector("[data-kr-file]");
  var transformBox = document.querySelector("[data-kr-transform]");
  var zoom = document.querySelector("[data-kr-zoom]");
  var zoomOut = document.querySelector("[data-kr-zoomout]");
  var rot = document.querySelector("[data-kr-rot]");
  var rotOut = document.querySelector("[data-kr-rotout]");
  var textInput = document.querySelector("[data-kr-input]");

  var front = (stage.getAttribute("data-front") || "18.2,47.4,25.7,43.1").split(",").map(Number);
  var back = (stage.getAttribute("data-back") || "58.5,55,25.5,34").split(",").map(Number);

  /* design state — enough to redraw identically at any resolution */
  var st = { file: null, url: null, natW: 0, natH: 0, scale: 1, rot: 0, flip: 1, fx: 0, fy: 0, text: "" };

  var measure = document.createElement("canvas").getContext("2d");

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  /* ---------------- photo geometry ----------------
     Cover-fit, then offset, then rotate about the photo's own centre.
     fx/fy are fractions of the drawn size so they survive any rescale. */
  function box(zoneW, zoneH) {
    var cover = Math.max(zoneW / st.natW, zoneH / st.natH);
    var w = st.natW * cover * st.scale;
    var h = st.natH * cover * st.scale;
    var cx = zoneW / 2 + clamp(st.fx, -0.5, 0.5) * w;
    var cy = zoneH / 2 + clamp(st.fy, -0.5, 0.5) * h;
    return { w: w, h: h, cx: cx, cy: cy };
  }

  function layoutPhoto() {
    if (!st.url || !st.natW) return;
    var zw = frontZone.clientWidth, zh = frontZone.clientHeight;
    if (!zw || !zh) return;
    var b = box(zw, zh);
    photoEl.style.width = b.w + "px";
    photoEl.style.height = b.h + "px";
    photoEl.style.left = "0px";
    photoEl.style.top = "0px";
    /* translate puts the centre where we want it, then rotate spins
       about that same centre because transform-origin is 50% 50% */
    photoEl.style.transform =
      "translate(" + (b.cx - b.w / 2) + "px," + (b.cy - b.h / 2) + "px)" +
      " rotate(" + st.rot + "deg) scaleX(" + st.flip + ")";
  }

  /* ---------------- text layout ----------------
     One printed row per line the customer typed. st.text is already
     cleaned (blank lines dropped, each line capped at LINE_MAX). */
  function makeLines(text) {
    return text.split("\n").filter(Boolean);
  }

  /* Text width scales linearly with font size, so measure once at a
     reference size and solve for the fit instead of looping sizes. */
  function fitText(text, zoneW, zoneH) {
    var lines = makeLines(text);
    if (!lines.length) return { lines: [], size: 6, lineH: 7.2 };
    var maxW = zoneW * 0.88, maxH = zoneH * 0.9;

    var REF = 100;
    measure.font = REF + 'px "' + TEXT_FONT + '", cursive';
    var widest = 0;
    lines.forEach(function (l) { widest = Math.max(widest, measure.measureText(l).width); });

    var byHeight = maxH / (lines.length * 1.2);
    var byWidth = widest > 0 ? maxW / (widest / REF) : byHeight;
    var size = Math.max(6, Math.min(byHeight, byWidth));
    return { lines: lines, size: size, lineH: size * 1.2 };
  }

  function layoutText() {
    var value = st.text || PLACEHOLDER;
    textEl.classList.toggle("is-placeholder", !st.text);
    var zw = backZone.clientWidth, zh = backZone.clientHeight;
    if (!zw || !zh) return;
    var f = fitText(value, zw, zh);
    textEl.innerHTML = "";
    f.lines.forEach(function (line) {
      var span = document.createElement("span");
      span.className = "kr__line";
      span.textContent = line;
      span.style.fontSize = f.size + "px";
      span.style.lineHeight = f.lineH + "px";
      textEl.appendChild(span);
    });
  }

  function relayout() { layoutPhoto(); layoutText(); }

  /* ---------------- photo input ---------------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function resetTransform() {
    st.scale = 1; st.rot = 0; st.flip = 1; st.fx = 0; st.fy = 0;
    if (zoom) zoom.value = 100;
    if (rot) rot.value = 0;
    syncOutputs();
    layoutPhoto();
  }

  function syncOutputs() {
    if (zoomOut) zoomOut.textContent = Math.round(st.scale * 100) + "%";
    if (rotOut) rotOut.textContent = Math.round(st.rot) + "°";
  }

  function setPhoto(file) {
    if (!file || !/^image\//.test(file.type)) return;
    if (st.url) URL.revokeObjectURL(st.url);
    st.file = file;
    st.url = URL.createObjectURL(file);

    var probe = new Image();
    probe.onload = function () {
      st.natW = probe.naturalWidth;
      st.natH = probe.naturalHeight;
      photoEl.src = st.url;
      photoEl.hidden = false;
      if (hintEl) hintEl.hidden = true;
      if (transformBox) transformBox.hidden = false;
      if (dropLabel) dropLabel.innerHTML = "<strong>" + escapeHtml(file.name) + "</strong> — tap to change";
      resetTransform();
    };
    probe.src = st.url;
  }

  if (drop) {
    drop.addEventListener("click", function () { fileInput.click(); });
    drop.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fileInput.click(); }
    });
    ["dragenter", "dragover"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("is-over"); });
    });
    ["dragleave", "drop"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove("is-over"); });
    });
    drop.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) setPhoto(e.dataTransfer.files[0]);
    });
  }
  if (fileInput) {
    fileInput.addEventListener("change", function () { if (this.files && this.files[0]) setPhoto(this.files[0]); });
  }
  if (zoom) zoom.addEventListener("input", function () { st.scale = +this.value / 100; syncOutputs(); layoutPhoto(); });
  if (rot) rot.addEventListener("input", function () { st.rot = +this.value; syncOutputs(); layoutPhoto(); });

  document.querySelectorAll("[data-kr-rot-step]").forEach(function (b) {
    b.addEventListener("click", function () {
      st.rot = ((st.rot + +b.getAttribute("data-kr-rot-step") + 180 + 360) % 360) - 180;
      if (rot) rot.value = st.rot;
      syncOutputs(); layoutPhoto();
    });
  });
  var flipBtn = document.querySelector("[data-kr-flip]");
  if (flipBtn) flipBtn.addEventListener("click", function () { st.flip *= -1; layoutPhoto(); });
  var resetBtn = document.querySelector("[data-kr-reset]");
  if (resetBtn) resetBtn.addEventListener("click", resetTransform);

  /* drag to reposition — pointer events cover mouse and touch */
  (function () {
    var dragging = false, sx = 0, sy = 0, startFx = 0, startFy = 0, b = null;
    frontZone.addEventListener("pointerdown", function (e) {
      if (!st.url) return;
      dragging = true;
      frontZone.setPointerCapture(e.pointerId);
      sx = e.clientX; sy = e.clientY;
      startFx = st.fx; startFy = st.fy;
      b = box(frontZone.clientWidth, frontZone.clientHeight);
      frontZone.classList.add("is-dragging");
    });
    frontZone.addEventListener("pointermove", function (e) {
      if (!dragging || !b) return;
      st.fx = clamp(startFx + (e.clientX - sx) / b.w, -0.5, 0.5);
      st.fy = clamp(startFy + (e.clientY - sy) / b.h, -0.5, 0.5);
      layoutPhoto();
    });
    ["pointerup", "pointercancel"].forEach(function (ev) {
      frontZone.addEventListener(ev, function () {
        dragging = false;
        frontZone.classList.remove("is-dragging");
      });
    });
  })();

  if (textInput) {
    textInput.addEventListener("input", function () {
      /* cap every line at LINE_MAX, including pasted text */
      var raw = this.value.replace(/\r/g, "");
      var capped = raw.split("\n").map(function (l) { return l.slice(0, LINE_MAX); }).join("\n");
      if (capped !== raw) {
        var caret = Math.min(this.selectionStart, capped.length);
        this.value = capped;
        this.setSelectionRange(caret, caret);
      }
      st.text = capped.split("\n")
        .map(function (l) { return l.replace(/\s+/g, " ").trim(); })
        .filter(Boolean)
        .join("\n");
      layoutText();
    });
  }

  window.addEventListener("resize", relayout);
  if (document.fonts && document.fonts.load) {
    document.fonts.load('32px "' + TEXT_FONT + '"').then(relayout).catch(relayout);
  }
  if (baseImg && !baseImg.complete) baseImg.addEventListener("load", relayout);
  relayout();

  /* ---------------- canvas output ---------------- */

  function drawPhotoInto(ctx, img, x, y, w, h) {
    var b = box(w, h);
    ctx.save();
    ctx.beginPath();
    ctx.rect(x, y, w, h);
    ctx.clip();
    ctx.translate(x + b.cx, y + b.cy);
    ctx.rotate(st.rot * Math.PI / 180);
    ctx.scale(st.flip, 1);
    ctx.drawImage(img, -b.w / 2, -b.h / 2, b.w, b.h);
    ctx.restore();
  }

  function drawTextInto(ctx, x, y, w, h, value, color) {
    var f = fitText(value, w, h);
    var blockH = f.lines.length * f.lineH;
    ctx.save();
    ctx.fillStyle = color;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = f.size + 'px "' + TEXT_FONT + '", cursive';
    f.lines.forEach(function (line, i) {
      ctx.fillText(line, x + w / 2, y + (h - blockH) / 2 + f.lineH * (i + 0.5));
    });
    ctx.restore();
  }

  function loadImage(src, cb) {
    var i = new Image();
    i.crossOrigin = "anonymous";
    i.onload = function () { cb(i); };
    i.onerror = function () { cb(null); };
    i.src = src;
  }

  /* Customer-facing composite: photo first, keyring on top, then text. */
  function buildPreview(cb) {
    loadImage(stage.getAttribute("data-base"), function (base) {
      if (!base) { cb(null); return; }
      var S = base.naturalWidth || 1200;
      var c = document.createElement("canvas");
      c.width = S; c.height = S;
      var ctx = c.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, S, S);

      var fz = { x: front[0] / 100 * S, y: front[1] / 100 * S, w: front[2] / 100 * S, h: front[3] / 100 * S };
      var bz = { x: back[0] / 100 * S, y: back[1] / 100 * S, w: back[2] / 100 * S, h: back[3] / 100 * S };

      function finish() {
        ctx.drawImage(base, 0, 0, S, S);            /* bezel over the artwork */
        drawTextInto(ctx, bz.x, bz.y, bz.w, bz.h, st.text || PLACEHOLDER, TEXT_COLOR);
        c.toBlob(function (b) {
          cb(b ? new File([b], "keyring-preview.png", { type: "image/png" }) : null);
        }, "image/png", 0.95);
      }

      if (st.url) {
        loadImage(st.url, function (p) {
          if (p) drawPhotoInto(ctx, p, fz.x, fz.y, fz.w, fz.h);
          finish();
        });
      } else {
        ctx.fillStyle = "#000000";
        ctx.fillRect(fz.x, fz.y, fz.w, fz.h);
        finish();
      }
    });
  }

  /* Production artwork: both plates, print resolution, labelled. */
  function buildLayout(cb) {
    var PW = 620, PH = Math.round(PW * (front[3] / front[2]));
    var pad = 60, gap = 80, capH = 54;
    var c = document.createElement("canvas");
    c.width = pad * 2 + PW * 2 + gap;
    c.height = pad * 2 + PH + capH;
    var ctx = c.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, c.width, c.height);

    var leftX = pad, rightX = pad + PW + gap, topY = pad;

    function finish() {
      drawTextInto(ctx, rightX, topY, PW, PH, st.text || PLACEHOLDER, "#000000");
      ctx.save();
      ctx.strokeStyle = "#bbb"; ctx.lineWidth = 2;
      ctx.strokeRect(leftX, topY, PW, PH);
      ctx.strokeRect(rightX, topY, PW, PH);
      ctx.fillStyle = "#666";
      ctx.font = "600 22px system-ui, sans-serif";
      ctx.textAlign = "center";
      ctx.fillText("PHOTO SIDE", leftX + PW / 2, topY + PH + 34);
      ctx.fillText("TEXT SIDE", rightX + PW / 2, topY + PH + 34);
      ctx.restore();
      c.toBlob(function (b) {
        cb(b ? new File([b], "keyring-print-layout.png", { type: "image/png" }) : null);
      }, "image/png", 0.95);
    }

    if (st.url) {
      loadImage(st.url, function (p) {
        if (p) drawPhotoInto(ctx, p, leftX, topY, PW, PH);
        finish();
      });
    } else finish();
  }

  /* ---------------- add to basket ---------------- */

  var form = document.querySelector("[data-keyring-form]");
  if (!form) return;
  var busy = false;

  form.addEventListener("submit", function (e) {
    if (busy) return; /* second pass — let the real post through */
    e.preventDefault();

    if (!st.file) { alert("Please upload a photo for the front of your keyring."); return; }
    if (!st.text) {
      alert("Please enter the text for the back of your keyring.");
      if (textInput) textInput.focus();
      return;
    }

    busy = true;
    var btn = form.querySelector("[data-kr-save]");
    if (btn) { btn.disabled = true; btn.classList.add("is-busy"); }

    function attach(sel, file, next) {
      var input = form.querySelector(sel);
      if (input && file) {
        var dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        input.disabled = false;
      }
      next();
    }

    var tProp = form.querySelector("[data-kr-text-prop]");
    if (tProp) { tProp.value = st.text; tProp.disabled = false; }

    attach("[data-kr-photo-file]", st.file, function () {
      buildLayout(function (layout) {
        attach("[data-kr-layout-file]", layout, function () {
          buildPreview(function (preview) {
            attach("[data-kr-preview-file]", preview, function () { form.submit(); });
          });
        });
      });
    });
  });
})();
